import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { BentoGridItem } from 'components/Product/BentoGrid/BentoGrid';

export default function BentoGridSlide({ gridItem }: { gridItem: BentoGridItem }) {
  const { image, title, longTitle, description, longDescription } = gridItem;
  const slideTitle = longTitle?.value || title.value;
  const slideDescription = longDescription?.value || description.value;
  return (
    <div className="flex w-full flex-col gap-11">
      <figure className="max-h-[80vh] w-full overflow-hidden rounded-3xl bg-blue">
        <Image className="h-full w-full object-cover" field={image} />
      </figure>
      <div>
        <h2
          className="heading-3"
          dangerouslySetInnerHTML={{ __html: sanitize(slideTitle as string) }}
        />
        <div
          className="paragraph-large"
          dangerouslySetInnerHTML={{ __html: sanitize(slideDescription as string) }}
        />
      </div>
    </div>
  );
}
